import GeneralImg from './general-img';
export default GeneralImg;
